import { createContext, useContext, useState, ReactNode } from "react";
import SummerYouLoader from "../components/summeryou-loader";

const LoaderContext = createContext();

export const LoaderProvider = ({children}) => {
    const [loading, setLoading] = useState(false);

    const showLoader = () => setLoading(true);
    const hideLoader = () => setLoading(false);

    return(
        <LoaderContext.Provider value={{showLoader, hideLoader}}>
            {children}
            {loading && <SummerYouLoader/>}
        </LoaderContext.Provider>
    )
}

export const useLoader = () => {
    const context = useContext(LoaderContext);
    if (!context)
        throw new Error("useLoader must be used within LoaderProvider");

    return context;
}

